import { NeoState } from '../../Reducers.interface';
import { ILocation } from '../../../Models/DTO/Location.models';
import { createSelector } from 'reselect';
import { keyBy } from 'lodash-es';

export const selectLocationList = (state: NeoState): ILocation[] => state.provider.locations;

export const selectLocationById = (locationId: string) => (state: NeoState): ILocation =>
  state.provider.locations.find((item: ILocation) => item.uuid === locationId);

export const selectLocationsMap = createSelector(selectLocationList, (locations) =>
  keyBy(locations, 'id'),
);
